import vinh_phu from "../../../assets/images/vinh_phu.svg";
import { Divider } from "@mui/material";
import vtc from "../../../assets/images/vtc.svg";

export default function BusinessStrategic() {
  return (
    <div className="w-full bg-[#f8ffff] lg:px-[120px] lg:py-[40px]">
      <div className="container mx-auto p-3 w-full">
        <div className="w-full flex flex-col gap-2 lg:flex-col lg:items-center lg:justify-center lg:gap-2">
          <p className="text-[28px] text-[#033F6A] font-semibold">
            Đối tác chiến lược
          </p>
          <p className="text-[16px] text-[#333333] font-normal">
            Chúng tôi hợp tác với các tổ chức, doanh nghiệp hàng đầu để cung cấp
            các giải pháp toàn diện và hiệu quả nhất
          </p>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-1 md:gap-16">
          <div className="mt-4 block lg:hidden">
            <Divider />
          </div>
          <div className="w-full flex flex-col gap-6 lg:flex-row lg:mt-8 lg:items-center lg:h-[350px]">
            <div className="w-full lg:w-3/12">
              {" "}
              <div className="w-full h-[91px] lg:w-[250px] lg:h-[250px]  lg:shadow-custom lg:rounded-full lg:flex lg:items-center lg:justify-center mt-4 rounded-[20px] flex items-center justify-center border border-solid border-[#F1F0F0] bg-white">
                <img src={vinh_phu} alt="vp" className="max-w-full h-auto" />
              </div>
            </div>
            <div className="w-full lg:w-9/12 lg:mr-24">
              <div className="flex flex-col gap-2 lg:flex-col lg:gap-3 lg:h-[220px] lg:w-full">
                <p className="text-[20px] font-semibold text-[#1375B7]">
                  CÔNG TY CỔ PHẦN THƯƠNG MẠI NGÔI SAO VĨNH PHÚ
                </p>
                <div className="flex flex-col gap-2 lg:flex-col lg:gap-3 ">
                  <p className="text-[16px] text-[#333333] font-normal  ">
                    BlueSkyIT và Công ty Cổ phần Ngôi sao Vĩnh Phú tự hào về mối
                    quan hệ hợp tác chiến lược trong việc phát triển các sản
                    phẩm sức khỏe chất lượng cao, nổi bật là dòng sản phẩm dầu
                    bơ ép lạnh Keyavo. Với kinh nghiệm và uy tín của Ngôi sao
                    Vĩnh Phú trong lĩnh vực chăm sóc sức khỏe, sự hợp tác này
                    không chỉ giúp tối ưu hóa quy trình sản xuất mà còn đảm bảo
                    sự kiểm soát chất lượng cao nhất cho sản phẩm trước khi đến
                    tay người tiêu dùng.
                  </p>
                  <p className="text-[16px] text-[#333333] font-normal ">
                    BlueSkyIT mang đến sự đổi mới công nghệ và chuyên môn trong
                    phát triển sản phẩm sức khỏe, trong khi Ngôi sao Vĩnh Phú
                    đóng vai trò quan trọng trong mạng lưới phân phối và tiếp
                    thị sản phẩm. Sự kết hợp này nhằm nâng cao giá trị cốt lõi
                    của dầu bơ Keyavo, không chỉ tập trung vào lợi ích sức khỏe
                    mà còn cam kết bảo vệ chất lượng nguyên bản của từng giọt
                    dầu. Đây là mối quan hệ chiến lược lâu dài giúp hai bên tận
                    dụng sức mạnh tổng hợp để mang đến những giá trị bền vững
                    cho khách hàng, đồng thời thúc đẩy sự phát triển chung trong
                    ngành hàng chăm sóc sức khỏe tự nhiên.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 block lg:hidden">
            <Divider />
          </div>
          <div className="w-full mt-4 flex flex-col gap-6 border border-[#e1f7ff] bg-[#e1f7ff] lg:h-[350px] px-[8px]  py-[8px] rounded-[24px] lg:flex-row-reverse lg:mt-8 lg:items-center   ">
            <div className="w-full lg:w-3/12">
              {" "}
              <div className="w-full h-[91px] lg:w-[250px] mx-auto lg:h-[250px] lg:shadow-custom lg:rounded-full lg:flex lg:items-center lg:justify-center mt-4 rounded-[20px] flex items-center justify-center border border-solid border-[#F1F0F0] bg-white">
                <img src={vtc} alt="vp" className="max-w-full h-auto" />
              </div>
            </div>
            <div className="w-full lg:w-9/12">
              <div className="flex flex-col gap-2 lg:flex-col lg:gap-3 lg:h-[250px] lg:w-full">
                <p className="text-[20px] font-semibold text-[#1375B7]">
                  ĐÀI TRUYỀN HÌNH KỸ THUẬT SỐ VTC
                </p>
                <div className="flex flex-col gap-2 lg:flex-col lg:gap-3">
                  <p className="text-[16px] text-[#333333] font-normal ">
                    Với vai trò là đối tác chiến lược bảo trợ truyền thông, VTC
                    và BlueSkyIT đã xây dựng mối quan hệ hợp tác bền vững nhằm
                    lan tỏa những giá trị và thông điệp của các sản phẩm và dịch
                    vụ của BlueSkyIT đến công chúng. Sự bảo trợ truyền thông của
                    VTC, một đơn vị truyền hình uy tín, giúp BlueSkyIT tiếp cận
                    với một lượng lớn khán giả tiềm năng, đồng thời củng cố hình
                    ảnh thương hiệu trên thị trường.
                  </p>
                  <p className="text-[16px] text-[#333333] font-normal ">
                    Sự hợp tác này không chỉ đơn thuần là hỗ trợ truyền thông,
                    mà còn là sự phối hợp chiến lược trong việc xây dựng nội
                    dung, tối ưu hóa các kênh phát sóng và sáng tạo những chiến
                    dịch quảng bá phù hợp với từng sản phẩm của BlueSkyIT. VTC
                    với sức mạnh truyền thông và kinh nghiệm dày dặn, góp phần
                    gia tăng sự hiện diện của các sản phẩm chủ lực như Blue Rise
                    và dầu bơ Keyavo, thu hút sự quan tâm của khách hàng và nâng
                    cao uy tín thương hiệu BlueSkyIT.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="mt-4 block lg:hidden">
          <Divider />
        </div>
        <div className="w-full flex flex-col gap-6 lg:flex-row lg:mt-8 lg:items-center lg:gap-5">
          <div className="w-full h-[91px] lg:w-[600px]  lg:h-[200px] lg:shadow-custom lg:rounded-full lg:flex lg:items-center lg:justify-center mt-4 rounded-[20px] flex items-center justify-center border border-solid border-[#F1F0F0] bg-white">
            <img src={vinh_phu} alt="vp" className="max-w-full h-auto" />
          </div>
          <div>
            <p className="text-[20px] font-semibold text-[#1375B7]">
              CÔNG TY CỔ PHẦN THƯƠNG MẠI NGÔI SAO VĨNH PHÚ
            </p>
            <p className="text-[16px] text-[#333333] font-normal">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ac
              congue elit. Pellentesque quis feugiat ex. Pellentesque ac elit at
              quam porttitor mollis. Aliquam pretium vitae lectus quis pretium.
              Vestibulum vitae finibus turpis. Nulla venenatis vulputate velit
              eget lobortis. Phasellus cursus posuere nunc, et malesuada mauris
              porta a. Nunc semper odio eros, non ultrices lorem posuere eget.
              Curabitur tempus odio non sagittis posuere. Pellentesque in
              posuere ipsum, interdum cursus lectus.{" "}
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
}
